<template>
    <div class="content-box">
        <Title/>

        <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal">
            <el-menu-item
            :index="String(index + 1)"
            v-for="(i, index) of dataNav"
            :key="index"
            @click="handleSelect(index)">
            {{i.label}}</el-menu-item>
        </el-menu>

        <div class="mobile-select">
            <el-select
            v-model="name"
            @change="handleSelect2">
                <el-option
                v-for="item in dataNav"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </div>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "comments",
    data() {
        return {
            activeIndex: '1',
            name: '曹磊',
            dataNav: [
                {
                    value: '曹磊 供应链',
                    label: '曹磊'
                },
                {
                    value: '张周平 供应链',
                    label: '张周平'
                },
                {
                    value: '莫岱青 供应链',
                    label: '莫岱青'
                },
                {
                    value: '陈虎东 供应链',
                    label: '陈虎东'
                },
            ],
            params: {
                json: 0,
            }
        }
    },
    created() {
    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", this.dataNav[0].value);
    this.$store.dispatch("getText");
  },
  methods: {
    handleSelect(index) {
      this.$store.commit("changeKeys", this.dataNav[index].value);
      this.$store.dispatch("getText");
    },
    handleSelect2(value) {
      this.$store.commit("changeKeys", value);
      this.$store.dispatch("getText");
    },
  },
}
</script>